export default __webpack_public_path__ + "static/media/business-301a.6b958ad6.jpg";